import { controls, currencyToNumber, grouped } from "../../controls";


const subdaybook = {
  label: "Sub Daybook",
  starting: true,
  url: "subdaybook",
  pageLabel: "SuDaybook",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Branch" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Branch", defaultValue: "assigned_branch", placeHolder: "Branch Code", name: "branch_code", fastpath: "branches" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "branch_display" }),

    ...controls.magicDateLabel({ label: "Date", target: "as_on_date" }),
    ...controls.magicDate({ dateType: "ontype", default: "3 years ago", isRequired: true, name: "as_on_date", width: "col-sm-2" }),
    ...controls.magicDateLabel({ label: "", width: "col-sm-2" }),

    ...controls.displayText({ label: "GL" }),
    ...controls.oc({ c: "Product", placeHolder: "GL Code", name: "gl_code", fastpath: "gls" }),
    ...controls.showData({ displaytype: "capital", data: "gl_display" }),

    ...grouped.grouping('basic'),
    ...grouped.separation('advance'),
    ...grouped.comparative('advance'),

  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "Sub Daybook",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },

    filterable: true,
    sortable: true,
    defaultsTo: 0,
    textReportProps: {
      '132': {
        filename: `Sub Daybook $pageData.as_on_date$.oro`,
        empty: true,
        format: {},
        header: "default",
        footer: "default"
      }
    },
    reportProps: { searchable: true, sortable: true },
    pivotable: true,
    charts: {
      pie: {
        row: { targetfield: 'all_total', flabel: 'gl_display' },
        column: { targetrow: 'grand_total' },
        // colors:[...Array(100).keys()].map(r=>chroma.random())
      }
    },
    // pivot:true,
    extraRows: {
      location: "top",
      fields: ["credit_vouchers", "cash_credit", "transfer_credit", "clearing_credit", "credit_total", "debit_vouchers"],
      subtotals: {
        by: "bs_or_pl",
        displayIn: "gl_display",
        labels: {
          bs: "Balance Sheet Total", pl: "Profit & Loss Total"
        },
        // subtotals: {
        //   by: "gl_code",
        //   displayIn: "gl_code",
        //   groupsOnly: false,
        // },
        // otherstat: [{ type: "count", label: "Count" }, { type: "avg", label: "Average", }, { type: "median", label: "Median" }], 
      },
      grandtotal: { type: "fixed", displayIn: "gl_display", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Account Number",
        accessor: "account_number",
        width: 100,
        // align: "right",
        width132: { size: 7 },
        drilldown: { fastpath: "acstat", field: "account_number", other: { as_on_date: "as_on_date" } }
      },
      {
        Header: "Name",
        accessor: "account_name",
        width: 100,
        // align: "right",
        width132: { size: 7 },
        drilldown: { fastpath: "acstat", field: "account_number", other: { as_on_date: "as_on_date" } }
      },
      {
        Header: "Particulars",
        accessor: "particulars",
        rwidth: "*",
        width132: { size: 20, fieldalign: 'left' },
      },
      {
        Header: "Credit",
        columns: [
          {
            Header: "Cash",
            accessor: "cash_credit",

            width: 200,
            type: "currency",
            width132: { size: 12, },
          },
          {
            Header: "Transfer",
            accessor: "transfer_credit",

            width: 200,
            type: "currency",
            width132: { size: 13, comma: true },
          },
          {
            Header: "Clearing",
            accessor: "clearing_credit",

            width: 200,
            type: "currency",
            width132: { size: 12 },
          },
          {
            Header: "Total",
            accessor: "credit_total",
            width132: { size: 12 },
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'cash_credit' }, { source: 'row', field: 'transfer_credit' }, { source: 'row', field: 'clearing_credit' }
              ], resultVar: 'total'
            }],
            type: "currency",
            // back: (d) => currencyToNumber(d['debit_total']) == currencyToNumber(d['credit_total']) ? "orange" : "white",
          },
        ]
      },
      {
        Header: "Debit",
        columns: [
          {
            Header: "Cash",
            accessor: "cash_debit",

            width: 200,
            type: "currency",
            width132: { size: 12 },
          },
          {
            Header: "Transfer",
            accessor: "transfer_debit",

            width: 200,
            type: "currency",
            width132: { size: 12 },
          },
          {
            Header: "Clearing",
            accessor: "clearing_debit",

            width: 200,
            type: "currency",
            width132: { size: 12 },
          },
          {
            Header: "Total",
            accessor: "debit_total",
            width132: { size: 12 },
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'row', field: 'cash_credit' }, { source: 'row', field: 'transfer_credit' }, { source: 'row', field: 'clearing_credit' }
              ], resultVar: 'total'
            }],
            type: "currency",
            // back: (d) => currencyToNumber(d['debit_total']) <= currencyToNumber(d['credit_total']) ? "orange" : "white",
          },
        ]
      },

      {
        Header: "Total",
        hide: true,
        columns: [
          {
            Header: "Total",
            accessor: "all_total",
            width132: { size: 13, },
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [
                { source: 'row', field: 'cash_credit' }, { source: 'row', field: 'transfer_credit' }, { source: 'row', field: 'clearing_credit' }, { source: 'row', field: 'cash_debit' }, { source: 'row', field: 'transfer_debit' }, { source: 'row', field: 'clearing_debit' }
              ], resultVar: 'total'
            }],
            type: "currency",
          },
        ]
      },

    ]
  }
};

export default subdaybook;